module.exports = __webpack_public_path__ + "img/edit-profile-pic.1dd29df8.svg";